module.exports = __webpack_public_path__ + "static/media/greater-than-equal.9de56026.svg";